import { useQuery } from "react-query";
import { useAccessToken } from "hooks/useAccessToken";
import { QUERY_STALE_TIME } from "utils/constants";
import { useParams } from "react-router-dom";
import queryFn from "ApiLayer/BuildingReports/Recommendations/queryAverageMarginalAbatementCostByMeasureCategoryChart";

export const useAverageMarginalAbatementCostByMeasureCategoryChart = () => {
    const accessToken = useAccessToken();
    const { buildingModelCarbonReductionPlanId } = useParams();
    if (!buildingModelCarbonReductionPlanId) throw new Error("BuildingModelRunUid param needs to be defined");

    return useQuery({
        queryKey: [
            buildingModelCarbonReductionPlanId,
            "carbonReductionPlanReport",
            "buildingModelRecommendationsAverageMarginalAbatementCostByMeasureCategoryChart",
        ],
        queryFn: async () => queryFn(accessToken, buildingModelCarbonReductionPlanId),
        staleTime: QUERY_STALE_TIME,
    });
};
